import { render, staticRenderFns } from "./N3StatisticsCard.vue?vue&type=template&id=0550382d"
import script from "./N3StatisticsCard.vue?vue&type=script&lang=ts"
export * from "./N3StatisticsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports